import React from "react";

import "../report-styles/uploadConfirmationModal.scss";
import EscapeOutside from "react-escape-outside";

const Modal = ({ handleClose, show, children }) => {
  return (
    <div className={show ? "modal display-block" : "modal display-none"}>
      <EscapeOutside onEscapeOutside={handleClose}>
        <div className="wrapper-modal">
          <section className="modal-main">{children}</section>
        </div>
      </EscapeOutside>
    </div>
  );
};

const UploadConfirmationModal = ({ handleHide, show, data }) => {
  return (
    <section className="mmodal-section">
      {/* <h3 className="ex-title">Modal Type: 1</h3> */}

      <Modal show={show} handleClose={handleHide}>
        <div className="modal-header">
          <div className="headline">
            <div className="main-headline">
              {data.is_error === 1 ? "Error Uploading" : "Uploading Successful"}
            </div>
            <div className="sub-headline">Check the server response below</div>
          </div>
        </div>
        <div className="modal-body">
          <div className="basic">
            <p className="response">{data.message}</p>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default UploadConfirmationModal;
